export default __webpack_public_path__ + "static/media/image34tum.d7efc51d.jpg";